goog.provide('el8.appshared.dialog.imagesZoom');

goog.require('el8.uiwidget.ImageFeed');
goog.require('el8.uiwidget.NewDialog');
goog.require('el8.template.appshared.dialog.imagesZoom');
goog.require('el8.apphome.docMgr.util');
goog.require('el8.ptdata.model.documentImage');
goog.require('el8.app.pageLayout');

el8.appshared.dialog.imagesZoom = (function() {
    
    var _feed = null;
    
    var that = new el8.uiwidget.NewDialog({
        title: '',
        width: function() { return Math.min(el8.app.pageLayout.getAppWidth() - 50, 1750); },
        height: function() { return el8.app.pageLayout.getAppHeight() - 100; },
        position: 'center',
        showXButton: true
    });
    
    var showFeed = function(divElt, images, imageWidth) {
        
        var $feedElt = $('<div>').addClass('.zoom-images-feed');
        divElt.append($feedElt);

        _feed = new el8.uiwidget.ImageFeed({
            container: $feedElt,
            name: 'zoomed-images',
            emptyMsg: 'Sorry, no images could be found.',
            imageWidth: imageWidth,
            moreTrigger: '#zoomed-images-more-btn',
            rendererFn: function() {
                // This renders the loading... shell for each image
                return function(item, feedId) {
                    return el8.template.appshared.dialog.imagesZoom.image({
                        image: item['id']  // the URL
                    });
                };
            },
            pageSize: 5,
            skeletonFn: function() {
                return el8.template.appshared.dialog.imagesZoom.imageFeed({});
            }
        });
        _feed.loadImages(images);
        _feed.display();
    };
    
    var super_show = that.show;
    that.show = function(spec) {
        super_show.call(that);
        var images = spec.images; // list of urls
        showFeed(that.getContentElt(), images, '98%');
        $('input[name="esc"]', that.getContentElt()).focus();
    };
    
    var super_hide = that.hide;
    that.hide = function() {
        _feed.destroy();
        super_hide.call(that);
    };
    
    return that;

})();

